import { useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'

import { getEnvironment } from 'helpers'

import { selectIsInContextShown } from 'root-redux/selects/common'

export const useInContextInitialization = () => {
  const isInContextShown = useSelector(selectIsInContextShown)
  const { isStageEnvironment } = getEnvironment()

  useLayoutEffect(() => {
    if (!isStageEnvironment || !isInContextShown) return

    const initialScript = document.createElement('script')
    const externalScript = document.createElement('script')

    initialScript.type = 'text/javascript'
    initialScript.text = `
      var _jipt = [];
      _jipt.push(['project', 'fbd54473040091356ab06a94153a76ce']);
      _jipt.push(['domain', 'gismart']);
    `

    externalScript.type = 'text/javascript'
    externalScript.src = '//cdn.crowdin.com/jipt/jipt.js'
    externalScript.async = true

    document.body.appendChild(initialScript)
    document.body.appendChild(externalScript)
  }, [isStageEnvironment, isInContextShown])
}
